import { useEffect, useState } from "react";
import api, { API_URL } from "../services/api";

import "../styles/adBanner.css";

function AdBanner() {
  const [ads, setAds] = useState([]);

  useEffect(() => {
    fetchAds();
  }, []);

  const fetchAds = async () => {
    try {
      const response = await api.get("/ads");

      setAds(response.data);

    } catch (error) {
      console.error(error);
    }
  };

  // Hide the section if there are no ads
  if (ads.length === 0) {
    return null;
  }

  const ad = ads[0];

  return (
    <section className="ad-banner">

      <a
        href={ad.redirect_url}
        target="_blank"
        rel="noopener noreferrer"
      >

        <img
          src={
            ad.image_url
              ? `${API_URL}${ad.image_url}`
              : "https://via.placeholder.com/1200x300?text=Advertisement"
          }
          alt={ad.title}
        />

      </a>

    </section>
  );
}

export default AdBanner;